import React from 'react'
import { Helmet } from 'react-helmet'
import Register from 'components/indy/registration/index'

const SystemRegister = () => {
  return (
    <div>
      <Helmet title="Register" />
      <Register />
    </div>
  )
}

export default SystemRegister
